import React from 'react';
import './LoaderOverlay.css';

interface LoaderOverlayProps {
  message?: string;
}

const LoaderOverlay: React.FC<LoaderOverlayProps> = ({ message = "Processing..." }) => {
  return (
    <div className="signature-loader-overlay">
      <div className="loader-box">
        <div className="spinner" />
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default LoaderOverlay;
